module.exports = __webpack_public_path__ + "img/18.f29e34a0.png";